import * as cart from '@shopify/theme-cart';
if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector('form');
            this.form.querySelector('[name=id]').disabled = false;
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.buyNowButton = this.querySelector('[name=buy_now]');
            if (this.buyNowButton) {
                this.buyNowButton.addEventListener('click', this.onBuyNowHandler.bind(this));
            }
            this.cartComponent = document.querySelector('cart-component');
        }
        onSubmitHandler(evt) {
            evt.preventDefault();
            const submitButton = this.querySelector('[type="submit"]');
            if (submitButton.classList.contains('-loading'))
                return;
            this.handleErrorMessage();
            submitButton.setAttribute('aria-disabled', true);
            submitButton.classList.add('-loading');
            this.querySelector('.loading-overlay__spinner').classList.remove('u-hide');
            const formData = new FormData(this.form);
            const id = formData.get('id');
            const quantity = formData.get('quantity') || 1; // Obtener la cantidad seleccionada
            console.log(id, quantity);
            cart.addItem(Number(id), { quantity: Number(quantity) }) // Pasar la cantidad a la función
                .then(this.onSuccess.bind(this))
                .catch(this.onError.bind(this))
                .finally(() => {
                submitButton.setAttribute('aria-disabled', false);
                submitButton.classList.remove('-loading');
                fbq('track', 'AddToCart');
                document.querySelectorAll('cart-icon').forEach((icon) => {
                    console.log(icon);
                    icon.calculateItems();
                });
                submitButton.removeAttribute('aria-disabled', true);
                submitButton.classList.remove('-loading');
                this.querySelector('.loading-overlay__spinner').classList.add('u-hide');
            });
        }
        onBuyNowHandler() {
            const formData = new FormData(this.form);
            const id = formData.get('id');
            const quantity = formData.get('quantity') || 1;
            cart.addItem(Number(id), { quantity: Number(quantity) })
                .then(() => {
                document.querySelector('.bss-checkout').click();
            })
                .catch(this.onError.bind(this));
        }
        onSuccess(cart) {
            console.dir(cart);
            document.querySelector('cart-component').addItem();
            this.cartComponent.open(); // Abrir el carrito en lugar de mostrar un toast
        }
        onError(error) {
            console.error(error);
            this.handleErrorMessage('Ya no es posible agregar más productos');
        }
        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper =
                this.errorMessageWrapper ||
                    this.querySelector('.product-form__error-message-wrapper');
            this.errorMessage =
                this.errorMessage ||
                    this.errorMessageWrapper.querySelector('.product-form__error-message');
            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
                this.errorMessageWrapper.classList.remove('u-hide');
            }
            else {
                this.errorMessage.textContent = '';
                this.errorMessageWrapper.classList.add('u-hide');
            }
        }
    });
}
